// Mock data for Morning Sunday Teer website

// Today's result
export const todayResult = {
  date: '26/07/2026',
  firstRound: {
    time: '10:30 AM',
    number: '16',
    status: 'declared'
  },
  secondRound: {
    time: '11:30 AM',
    number: '92',
    status: 'declared'
  }
};

// Previous results
export const previousResults = [
  { date: '26/07/2026', fr: '16', sr: '92' },
  { date: '25/07/2026', fr: '45', sr: '78' },
  { date: '24/07/2026', fr: '23', sr: '67' },
  { date: '23/07/2026', fr: '89', sr: '34' },
  { date: '22/07/2026', fr: '56', sr: '12' },
  { date: '21/07/2026', fr: '34', sr: '89' },
  { date: '20/07/2026', fr: '67', sr: '45' },
  { date: '19/07/2026', fr: '12', sr: '56' },
  { date: '18/07/2026', fr: '78', sr: '23' },
  { date: '17/07/2026', fr: '90', sr: '14' },
  { date: '16/07/2026', fr: '45', sr: '67' },
  { date: '15/07/2026', fr: '23', sr: '89' },
  { date: '14/07/2026', fr: '56', sr: '34' },
  { date: '13/07/2026', fr: '78', sr: '12' },
  { date: '12/07/2026', fr: '34', sr: '56' }
];

// Common numbers
export const commonNumbers = [
  { number: '23', frequency: 'High', lastSeen: '2 days ago' },
  { number: '45', frequency: 'Medium', lastSeen: '1 day ago' },
  { number: '67', frequency: 'High', lastSeen: '3 days ago' },
  { number: '89', frequency: 'Medium', lastSeen: '2 days ago' },
  { number: '12', frequency: 'Low', lastSeen: '5 days ago' },
  { number: '34', frequency: 'High', lastSeen: '1 day ago' },
  { number: '56', frequency: 'Medium', lastSeen: '4 days ago' },
  { number: '78', frequency: 'High', lastSeen: '2 days ago' }
];

// House targets/predictions
export const houseTargets = [
  { house: 'Shillong House', fr: '23-45-67', sr: '89-12-34' },
  { house: 'Meghalaya Target', fr: '34-56-78', sr: '90-23-45' },
  { house: 'Morning Special', fr: '45-67-89', sr: '12-34-56' },
  { house: 'Sunday Target', fr: '56-78-90', sr: '23-45-67' }
];

// FAQ data
export const faqs = [
  {
    question: 'What is the Morning Teer Result?',
    answer: 'The Morning Teer Result is the official winning two-digit number derived from the total number of arrows counted during a morning archery session. The last two digits of the final arrow count become the winning result.'
  },
  {
    question: 'What is Morning Sunday Teer?',
    answer: 'Morning Sunday Teer refers to the Sunday morning edition of the traditional archery-based Teer game. Many followers check Sunday results because weekends often attract greater interest and community discussions.'
  },
  {
    question: 'How is Shillong Morning Teer different from other number games?',
    answer: 'Shillong Morning Teer is based on live archery events rather than computer-generated draws. The winning number comes from the actual arrow count, giving the game a strong cultural and traditional identity.'
  },
  {
    question: 'Can old Morning Teer Result records predict future results?',
    answer: 'No. Previous Morning Teer Result records cannot predict future outcomes. Many followers study historical data only to observe trends and understand number patterns over time.'
  },
  {
    question: 'Why do people follow Shillong Morning Teer every day?',
    answer: 'People follow Shillong Morning Teer because they enjoy its traditional archery background, daily number announcements, historical analysis, and the strong sense of community surrounding the game.'
  },
  {
    question: 'What is the best way to check the official Morning Teer Result?',
    answer: 'The best approach is to use reliable and trusted Teer result platforms that publish official updates promptly after the archery session concludes.'
  }
];

// Overview table data
export const overviewData = [
  { topic: 'Game Type', details: 'Traditional archery-based number game' },
  { topic: 'Popular Region', details: 'Shillong, Meghalaya' },
  { topic: 'Result Method', details: 'Based on arrow count' },
  { topic: 'Daily Results', details: 'Released according to the official schedule' },
  { topic: 'Number Range', details: 'Two-digit winning number' },
  { topic: 'Interest Level', details: 'Very high among regular followers' },
  { topic: 'Result Tracking', details: 'Online and offline' },
  { topic: 'Analysis', details: 'Weekly and monthly reviews' }
];
